import { userAgentParser } from "../config";

export const useIsTablet = () => {
  const device = userAgentParser.getDevice();
  return device.type === 'tablet';
}
